import { ApiModule } from "@/api/api-module"
import routes from './routes'

export class ApiOrg extends ApiModule {
  /**
   * Проверка статуса авторизации аккаунта
   */
  check() {
    return new Promise((resolve, reject) => {
      this.http.get(routes.check).then(response => {
        resolve( Boolean(response.status === 200) )
      }).catch(error => {
        resolve(false)
      })
    })
  }
  
  /**
   * Проверка доступности поста аккаунту
   *
   * @param {String} postId
   */
  checkAccess(postId) {
    return new Promise((resolve, reject) => {
      this.http.post(routes.checkAccess, { post_id: postId }).then(response => {
        if (response.data) {
          resolve(response.data)
        } else {
          reject('Error')
        }
      }).catch(error => {
        reject(error)
      })
    })
  }
  
  /**
   * Получение компаний аккаунта
   */
  getCompanies() {
    return new Promise((resolve, reject) => {
      this.http.get(routes.companies).then(response => {
        if (response.status === 200) {
          let companies = response.data.companies || []
          resolve(companies)
        } else {
          reject("Error")
        }
      }).catch(error => {
        reject(error)
      })
    })
  }
  
  /**
   * Получение доступов поста
   */
  getAccesses() {
    return new Promise((resolve, reject) => {
      this.http.post(routes.accessInterfaces).then(response => {
        if (response.status === 200 && response.data) {
          resolve(response.data)
        } else {
          reject("Error")
        }
      }).catch(error => {
        reject(error)
      })
    })
  }
  
  /**
   * Получение логотипа поста
   *
   * @param {String} postId
   */
  getLogo(postId = null) {
    return new Promise((resolve, reject) => {
      let params = postId
        ? { 'DMS-POST-ID': postId }
        : null
      
      this.http.get(routes.postLogo, { params }).then(response => {
        if (response.status === 200 && response.data) {
          let logo = response.data.logo || {}
          resolve(logo)
        } else {
          reject("Error")
        }
      }).catch(error => {
        reject(error)
      })
    })
  }
  
  /**
   * Информация о постах и компаниях
   */
  entitiesInfo(requestData) {
    return new Promise((resolve, reject) => {
      this.http.post(routes.entitiesInfo, requestData, this.config).then(
        response => {
          resolve(response.data)
        },
        error => {
          reject(this.normalizeError(error))
        }
      )
    })
  }
  
  tree(type='standard') {
    return new Promise((resolve, reject) => {
      this.http.get(routes.tree+'/'+type).then(response => {
        if (response.status === 200 && response.data && response.data.tree) {
          resolve( response.data.tree )
        } else {
          reject("OrgStructure API. Error occurres while getting server data ('tree()' method).")
        }
      }).catch(error => {
        console.warn(error)
        reject(error)
      })
    })
  }
  
  shortTree(elements){
    return new Promise((resolve, reject) => {
      this.http.post(routes.shortTree, elements).then(response => {
        resolve( response.data )
      }).catch(error => {
        reject(this.normalizeError(error))
      })
    })
  }
  
  /**
   * Список доступных компаний с постами
   */
  companiesPosts() {
    return new Promise((resolve, reject) => {
      this.http.get(routes.companies, this.config).then(
        response => {
          resolve(response.data.companies)
        },
        error => {
          reject(this.normalizeError(error))
        }
      )
    })
  }
  
  postsList(containerId = null) {
    return new Promise((resolve, reject) => {
      let apiPath = routes.postList.replace( "{containerId}", containerId ? containerId : "0" )
      
      this.http.get(apiPath).then(response => {
        if (response.status === 200 && response.data && response.data.posts) {
          resolve( response.data.posts )
        } else {
          reject("OrgStructure API. Error occurres while getting server data ('postsList' method).")
        }
      }).catch(error => {
        console.warn(error)
        reject(error)
      })
    })
  }
  
  /**
   * Список интерфейсов
   */
  accessInterfaces(postId) {
    return new Promise((resolve, reject) => {
      let conf = {}
      if (!!postId) {
        conf.headers = {
          "DMS-POST-ID": postId
        }
      }
      this.http.post(routes.accessInterfaces, {}, conf).then(
        response => {
          resolve(response.data)
        },
        error => {
          reject(this.normalizeError(error))
        }
      )
    })
  }
  
  /**
   * Получение оргсхемы
   * @returns {Promise<any>}
   */
  scheme(){
    return new Promise((resolve, reject) => {
      this.http.get(routes.scheme).then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(this.normalizeError(error));
        }
      )
    })
  }
  
  /**
   * Получение риглашений на пост
   * @param id
   * @returns {Promise<any>}
   */
  invite(id){
    return new Promise((resolve, reject) => {
      this.http.get(`${routes.invite}/${id}`).then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(this.normalizeError(error));
        }
      )
    })
  }
  
  /**
   * Получение риглашений на пост
   * @param data
   * @returns {Promise<any>}
   */
  createInvite(data){
    return new Promise((resolve, reject) => {
      this.http.put(routes.invite, data).then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(this.normalizeError(error));
        }
      )
    })
  }
  
  deleteInvite(id){
    return new Promise((resolve, reject) => {
      this.http.delete(`${routes.invite}/${id}`).then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(this.normalizeError(error));
        }
      )
    })
  }
  
  /**
   * Снятие с поста
   * @param id
   * @returns {Promise<any>}
   */
  dismiss(id){
    return new Promise((resolve, reject) => {
      this.http.get(`${routes.dismiss}/${id}`).then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(this.normalizeError(error));
        }
      )
    })
  }
  
  /**
   * Добавление контейнера
   * @param data
   * @returns {Promise<any>}
   */
  createContainer(data){
    return new Promise((resolve, reject) => {
      this.http.put(routes.container, data).then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(this.normalizeError(error));
        }
      )
    })
  }
  
  /**
   * Добавление поста
   * @param data
   * @returns {Promise<any>}
   */
  createPost(data){
    return new Promise((resolve, reject) => {
      this.http.put(routes.post, data).then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(this.normalizeError(error));
        }
      )
    })
  }
  
  /**
   * Получение данных поста
   * @param id
   * @returns {Promise<any>}
   */
  viewPost(id){
    return new Promise((resolve, reject) => {
      this.http.get(`${routes.post}/${id}`).then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(this.normalizeError(error));
        }
      )
    })
  }
  
  /**
   * Получение данных контенйера
   * @param id
   * @returns {Promise<any>}
   */
  viewContainer(id){
    return new Promise((resolve, reject) => {
      this.http.get(`${routes.container}/${id}`).then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(this.normalizeError(error));
        }
      )
    })
  }
  
  /**
   * Редактирование поста
   * @param id
   * @param data
   * @returns {Promise<any>}
   */
  updatePost(id, data){
    return new Promise((resolve, reject) => {
      this.http.patch(`${routes.post}/${id}`, data).then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(this.normalizeError(error));
        }
      )
    })
  }
  
  /**
   * Редактирование контейнера
   * @param id
   * @param data
   * @returns {Promise<any>}
   */
  updateContainer(id, data){
    return new Promise((resolve, reject) => {
      this.http.patch(`${routes.container}/${id}`, data).then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(this.normalizeError(error));
        }
      )
    })
  }
  
  
  /**
   * Удаляет контейнер по id
   * @param id
   * @returns {Promise<any>}
   */
  deleteContainer(id){
    return new Promise((resolve, reject) => {
      this.http.delete(`${routes.container}/${id}`).then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(this.normalizeError(error));
        }
      )
    })
  }
  
  /**
   * Удаляет пост
   * @param id
   * @param to_id
   * @returns {Promise<any>}
   */
  deletePost(id, to_id){
    return new Promise((resolve, reject) => {
      this.http.delete(`${routes.post}/${id}/${to_id}`).then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(this.normalizeError(error));
        }
      )
    })
  }
  
  /**
   * Возвращает вспомогательный деревья для оргструктуры (типы, роли)
   * @param type - тип деревьев
   * @returns {Promise<any>}
   */
  trees(type){
    return new Promise((resolve, reject) => {
      this.http.get(`${routes.trees}/${type}`).then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(this.normalizeError(error));
        }
      )
    })
  }
  
  /**
   * Дерво постов, за исключением поста id
   * @param id
   */
  treePosts(id){
    return new Promise((resolve, reject) => {
      this.http.get(`${routes.treePosts}/${id}`).then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(this.normalizeError(error));
        }
      )
    })
  }
  
  /**
   * Дерво типов
   */
  treeTypes(){
    return new Promise((resolve, reject) => {
      this.http.get(routes.type).then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(this.normalizeError(error));
        }
      )
    })
  }
  
  /**
   * Создание типа
   * @param data
   * @returns {Promise<any>}
   */
  createType(data){
    return new Promise((resolve, reject) => {
      this.http.put(routes.type, data).then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(this.normalizeError(error));
        }
      )
    })
  }
  
  /**
   * Редактирование типа
   * @param id
   * @param data
   * @returns {Promise<any>}
   */
  updateType(id, data){
    return new Promise((resolve, reject) => {
      this.http.patch(`${routes.type}/${id}`, data).then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(this.normalizeError(error));
        }
      )
    })
  }
  
  /**
   * Удаление типа
   * @param id
   * @returns {Promise<any>}
   */
  deleteType(id){
    return new Promise((resolve, reject) => {
      this.http.delete(`${routes.type}/${id}`).then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(this.normalizeError(error));
        }
      )
    })
  }
  
  /**
   * Дерево логотипов компании
   * @returns {Promise<any>}
   */
  logoTree(){
    return new Promise((resolve, reject) => {
      this.http.get(routes.logo).then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(this.normalizeError(error));
        }
      )
    })
  }
  
  /**
   * Создание логотипа
   * @param data
   * @returns {Promise<any>}
   */
  createLogo(data){
    return new Promise((resolve, reject) => {
      this.http.put(routes.logo, data).then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(this.normalizeError(error));
        }
      )
    })
  }
  
  /**
   * Редактирование логотипа
   * @param id
   * @param data
   * @returns {Promise<any>}
   */
  updateLogo(id, data){
    return new Promise((resolve, reject) => {
      this.http.patch(`${routes.logo}/${id}`, data).then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(this.normalizeError(error));
        }
      )
    })
  }
  
  /**
   * Удаляет пост
   * @param id
   * @returns {Promise<any>}
   */
  deleteLogo(id){
    return new Promise((resolve, reject) => {
      this.http.delete(`${routes.logo}/${id}`).then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(this.normalizeError(error));
        }
      )
    })
  }
  
  element(id){
    return new Promise((resolve, reject) => {
      this.http.get(`${routes.element}/${id}`).then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(this.normalizeError(error));
        }
      )
    })
  }
  
  changeContainerPosition(data){
    return new Promise((resolve, reject) => {
      this.http.patch(routes.change_position_container, data).then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(this.normalizeError(error));
        }
      )
    })
  }
  
  /**
   * Смена позиции поста
   * @param data
   * @returns {Promise<any>}
   */
  changePostPosition(data){
    return new Promise((resolve, reject) => {
      this.http.post(routes.change_position_post, data).then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(this.normalizeError(error));
        }
      )
    })
  }
  
  /**
   * Удаление компании
   * @param id
   * @returns {Promise<any>}
   */
  deleteCompany(id){
    return new Promise((resolve, reject) => {
      this.http.delete(`${routes.company}/${id}`).then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(this.normalizeError(error));
        }
      )
    })
  }
  
  /**
   * Удаленные посты
   * @returns {Promise<any>}
   */
  deletedPosts(){
    return new Promise((resolve, reject) => {
      this.http.get(routes.deleted_posts).then(
        response => {
          resolve(response.data.tree);
        },
        error => {
          reject(this.normalizeError(error));
        }
      )
    })
  }
  
  /**
   * Email адреса постов
   * @param data
   * @returns {Promise<any>}
   */
  postEmails(data){
    return new Promise((resolve, reject) => {
      this.http.post(routes.post_emails, data).then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(this.normalizeError(error));
        }
      )
    })
  }
}

let apiOrg = new ApiOrg("orgstructure")
export default apiOrg



// WEBPACK FOOTER //
// ./src/apps/org/api/orgstructure/index.js